import {
  batchPatchContentObject,
  getContentObjects,
} from '../../../lib/flotiq-client';
import { parseResponseErrors } from '../../../lib/flotiq-client/response-errors';

import { ErrorType, PopulateSpaceError } from './PopulateSpaceError';

export const updatePlugins = async (
  rwApiKey: string,
  roApiKey?: string,
  jwt?: string,
) => {
  try {
    const { body, status, ok } = await getContentObjects(jwt, undefined, {
      contentTypeName: '_plugin_settings',
      limit: 1000,
    });

    if (!ok) {
      throw parseResponseErrors(body, status);
    }

    const parsedPlugins = body.data.map((plugin) => ({
      ...plugin,
      settings: plugin.settings ? JSON.parse(plugin.settings) : plugin.settings,
    }));

    const pluginToUpdate = parsedPlugins.filter(
      ({ settings }) => !!settings?.api_key,
    );

    if (pluginToUpdate.length === 0) {
      return;
    }

    const updateBody = pluginToUpdate.map((plugin) => {
      return {
        id: plugin.id,
        ...(plugin.settings?.api_key
          ? {
              settings: JSON.stringify({
                ...plugin.settings,
                api_key: roApiKey || rwApiKey,
              }),
            }
          : {}),
      };
    });

    await batchPatchContentObject(
      jwt,
      undefined,
      '_plugin_settings',
      updateBody,
    );
  } catch (e) {
    if (e instanceof Error) {
      throw new PopulateSpaceError(e.message, ErrorType.PLUGINS);
    }
  }
};
